"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Seeker = void 0;
/**
 * Minimal token traverse helper used to create structure from tokens
 */
class Seeker {
    constructor(tokens) {
        this.tokens = tokens;
        this.index = -1;
    }
    next() {
        this.index++;
        return this.tokens[this.index] || {};
    }
    back() {
        this.index--;
    }
    peekBack() {
        return this.tokens[this.index - 1] || { type: "" };
    }
    peek(num = 1) {
        return this.tokens[this.index + num] || { type: "" };
    }
    flatBlock(start, end, isEndError) {
        let token = this.next();
        if (token.type !== start) {
            return [];
        }
        const block = [];
        let endIndex;
        while ((token = this.next())) {
            if (!token.type) {
                if (endIndex !== undefined) {
                    this.index = endIndex - 1;
                }
                return;
            }
            if (isEndError && isEndError(token)) {
                endIndex = this.index;
            }
            if (token.type === end) {
                return block;
            }
            else {
                block.push(token);
            }
        }
        return [];
    }
}
exports.Seeker = Seeker;
//# sourceMappingURL=seeker.js.map